import { render, staticRenderFns } from "./ConsultingExternalProfessionalSectionView.vue?vue&type=template&id=bb385a78&scoped=true&"
import script from "./ConsultingExternalProfessionalSectionView.vue?vue&type=script&lang=ts&"
export * from "./ConsultingExternalProfessionalSectionView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb385a78",
  null
  
)

export default component.exports